#import "../../../../../core-entity/graphql/fragments/account-for-core-entity-fragment.graphql"

mutation UpdateAccountForLead($input: AccountUpdateInput!) {
    accountUpdate(input: $input) {
        account {
            ...AccountForCoreEntityFragment
        }
    }
}
